import Container from './container'

export default Container



// WEBPACK FOOTER //
// ./src/components/SitesSearch/index.js